import { render, staticRenderFns } from "./btsp.vue?vue&type=template&id=60232958&scoped=true"
import script from "./btsp.vue?vue&type=script&lang=js"
export * from "./btsp.vue?vue&type=script&lang=js"
import style0 from "./btsp.vue?vue&type=style&index=0&id=60232958&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60232958",
  null
  
)

export default component.exports